import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Generics, Generic } from './generic.model';
import { environment } from './../../environments/environment';

@Injectable()
export class GenericService {

  constructor(private httpClient: HttpClient) {}

  items(query: any): Observable<Generics> {
    const params = new HttpParams({fromObject: query});
    params['front'] = true;
    return this.httpClient.get<Generics>(environment.api + '/generics', { params: params });
  }

  item(path: string): Observable<Generic> {
    return this.httpClient.get<Generic>(environment.api + '/generic/' + path);
  }

}

